import * as React from 'react';
import { ReactComponent as PlusIcon } from '@assets/plus.svg';

export default function ToastCloseButton() {
  return (
    <div className="Toastify__close-button">
      <PlusIcon/>
    </div>
  );
};
